/**
 * @fileOverView
 * @description Meter View<br>
 * @copyright 2015-present Flatirontek LLC
 **/

var AmpersandView = require('ampersand-view');
var MeterTemplate = require('../../templates/widgets/metertemplate.html');
var app = require('ampersand-app');

var MeterView = AmpersandView.extend({
    template: MeterTemplate,

    initialize: function (options) {
        this.model = app.meter;
    },

    render: function(){
        this.renderWithTemplate(this);
        //seats used comes from the member collection, not the meter record
        if(app.orgMembers) this.listenTo(app.orgMembers, 'add remove reset sync', this.renderSeats);
        this.renderSeats();
        return this;
    },

    renderSeats: function(){
        var el = this.query('[data-hook=seats]');
        if(!el) return;
        var seats = app.utils.orgSeats();
        el.textContent = seats.cap === Infinity
            ? seats.used + ' / no limit'
            : seats.used + ' / ' + seats.cap;
    },

    bindings: {
        "model.linkedPlan": {
            type: 'innerHTML',
            hook: 'plan'
        },
        "model.plansLink": {
            type: 'innerHTML',
            hook: 'plans-link'
        },
        "model.vybits": {
            type: 'text',
            hook: 'vybits'
        },
        "model.daily_count": {
            type: 'text',
            hook: 'daily'
        },
        "model.daily_reset": {
            type: 'text',
            hook: 'daily_reset'
        },
        "model.monthly_count": {
            type: 'text',
            hook: 'monthly'
        },
        "model.monthly_reset": {
            type: 'text',
            hook: 'monthly_reset'
        },
    }

});

module.exports = MeterView;
